import get from 'lodash/get'

import { getDynamicColumnFieldKey } from '@components/TimeLineGrid/helpers/getDynamicColumnFieldKey'

import { getPathString } from '@helpers'
import {
  ObjectDataRecord,
  TimeLineDTOType,
  TimeLineGridDataRecord,
  TimeLineGroupedData,
} from '@types'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

type Props = {
  groupedData: TimeLineGroupedData[]
  groupId?: string
  objectYKeyField: string
  config: TimeLineDTOType
  columnsObjectData: ObjectDataRecord[]
}

// Функция для формирования готовых для таблицы данных в зависимости от полученных данных
export const groupByObject = (props: Props): TimeLineGridDataRecord[] => {
  const { groupedData, groupId, objectYKeyField, config, columnsObjectData } = props

  return groupedData.map(item => {
    // Создаем новый объект для результата
    const result: TimeLineGridDataRecord = {
      id: item.yElement[objectYKeyField] + (groupId ? `_${groupId}` : ''),
      yElement: item.yElement,
      groupId,
      columnsInfo: {},
    } as TimeLineGridDataRecord

    columnsObjectData.forEach(columnItem => {
      const key = getDynamicColumnFieldKey(
        columnItem,
        config.objectX.fieldFromColumnsObjectToLink as EmbeddedObject[]
      )

      result[key] = item.xArray
        .filter(
          xArrayItem =>
            get(columnItem, getPathString(config.objectX.fieldFromColumnsObjectToLink)) ===
            get(xArrayItem, getPathString(config.objectX.linkToColumnsObject as EmbeddedObject[]))
        )
        .map(filteredItem => {
          return {
            ...filteredItem,
            columnInfo: columnItem,
          }
        })

      result.columnsInfo[key] = columnItem
    })

    return result
  })
}
